import { Aurelia, autoinject, bindable } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { AccountImportService, AccountData } from './account-import-service';

@autoinject
export class AccountsPreview {
	@bindable submit: () => void;

	get accountData(): AccountData[] {
		return this.importService.cleanAccountData();
	}

	get canImport() {
		return this.importService.rawAccountData && this.importService.rawAccountData.length > 0;
	}

	constructor(private importService: AccountImportService) {
	}
}
